var Theme = Theme || {};

Theme.MathJax = (function ($) {

    return {
        init: _init,
        ajaxInit: _ajaxInit
    };

    function _init() {
        _suppressMathContainerTabStops();
    }

    // MathJax v3 attaches its context menu to every <mjx-container> and sets
    // tabindex="0" so the menu can be invoked from the keyboard. The math
    // content inside is rendered with aria-hidden="true", so a screen-reader
    // user who tabs onto the container hears nothing — it is a focus stop
    // with no associated control (WCAG 2.4.3). Suppress the tab stop. Mouse
    // users can still right-click for the menu and click-to-zoom (when
    // configured) still works because both are independent of tabindex.
    function _suppressMathContainerTabStops() {
        var SELECTOR = 'mjx-container[tabindex="0"]';

        function deactivate(container) {
            container.setAttribute('tabindex', '-1');
        }

        document.querySelectorAll(SELECTOR).forEach(deactivate);

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var added = mutations[i].addedNodes;
                for (var j = 0; j < added.length; j++) {
                    var node = added[j];
                    if (node.nodeType !== 1) {
                        continue;
                    }
                    if (node.tagName === 'MJX-CONTAINER' && node.getAttribute('tabindex') === '0') {
                        deactivate(node);
                    } else if (node.querySelectorAll) {
                        node.querySelectorAll(SELECTOR).forEach(deactivate);
                    }
                }
            }
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    function abstractMathJax() {
        var $el = $('.abstract-response-placeholder');
        if (!$el.length) {
            return;
        }
        if (typeof window.MathJax?.typesetPromise !== 'function') {
            return;
        }
        window.MathJax.typesetPromise([$el.get(0)])
            .catch((err) => console.log(err.message));
    }

    function _ajaxInit() {
        abstractMathJax();
    }

})(jQuery);

$(function () {
    Theme.MathJax.init();
});

// If we are in a module context, export this module
'object' === typeof module && module.exports && (module.exports = Theme.MathJax);
